/**
 * @generated SignedSource<<c94d2df746c6234004e8588615b8f5e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CertType = "Kakao" | "Naver";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type simpleAuthConfirmRequestTokenMutation$variables = {
  birthday: string;
  certType: CertType;
  cxId: string;
  name: string;
  phone: string;
  reqTxId: string;
  token: string;
};
export type simpleAuthConfirmRequestTokenMutation$data = {
  readonly hometaxSimpleAuthConfirm: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
    readonly token: string | null | undefined;
  };
};
export type simpleAuthConfirmRequestTokenMutation = {
  response: simpleAuthConfirmRequestTokenMutation$data;
  variables: simpleAuthConfirmRequestTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "birthday"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "certType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cxId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phone"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reqTxId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "birthday",
        "variableName": "birthday"
      },
      {
        "kind": "Variable",
        "name": "certType",
        "variableName": "certType"
      },
      {
        "kind": "Variable",
        "name": "cxId",
        "variableName": "cxId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "phone",
        "variableName": "phone"
      },
      {
        "kind": "Variable",
        "name": "reqTxId",
        "variableName": "reqTxId"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "HometaxSimpleAuthConfirmOutput",
    "kind": "LinkedField",
    "name": "hometaxSimpleAuthConfirm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "simpleAuthConfirmRequestTokenMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "simpleAuthConfirmRequestTokenMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "eb13b02aa417ece15d23777c72b6e38f",
    "id": null,
    "metadata": {},
    "name": "simpleAuthConfirmRequestTokenMutation",
    "operationKind": "mutation",
    "text": "mutation simpleAuthConfirmRequestTokenMutation(\n  $name: String!\n  $phone: String!\n  $birthday: String!\n  $certType: CertType!\n  $reqTxId: String!\n  $token: String!\n  $cxId: String!\n) {\n  hometaxSimpleAuthConfirm(name: $name, phone: $phone, birthday: $birthday, certType: $certType, reqTxId: $reqTxId, token: $token, cxId: $cxId) {\n    result\n    token\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4a54eb62b8f1747a8236734131eadb3";

export default node;
